import request from '@/utils/microSeviceFormatRequest'
import rawRequest from '@/utils/request'

export function logout() {
  return request({
    url: '/api/account/logout',
    method: 'get'
  })
}

export function loginLog() {
  return rawRequest({
    url: '/api/account/LoginLog',
    method: 'post'
  })
}

export function getUserInfo() {
  return request({
    url: '/api/account/userinfo',
    method: 'get',
    params: {},
    timeout: 3 * 60 * 1000
  })
}

export function getUserMoreInfo() {
  return request({
    url: '/api/account/UserMoreInfo?version=3.0',
    method: 'get',
    params: {},
    timeout: 3 * 60 * 1000
  })
}

export function sendVerificationCode(email) {
  return rawRequest({
    url: '/api/Account/SendVerificationCode',
    method: 'post',
    data: { Email: email }
  })
}

export function verifyEmailCode(email, code) {
  return rawRequest({
    url: '/api/Account/VerifyEmailCode',
    method: 'post',
    data: { Email: email, Code: code }
  })
}

export function resetPassword(email, password, code) {
  return rawRequest({
    url: '/api/Account/ResetPassword',
    method: 'post',
    data: { Email: email, Password: password, Code: code }
  })
}

export function verifyTutorInfo(tuid, phone) {
  return rawRequest({
    url: '/api/Account/VerifyTutorInfo',
    method: 'post',
    data: { Tuid: tuid, Phone: phone }
  })
}

export function selectEyeProtectionMode(type) {
  return rawRequest({
    url: `/api/Account/SelectEyeProtectionMode?type=${type}`,
    method: 'post'
  })
}

/** 获取用户 Soft Mode：0 默认 / 1 护眼暗色（微服务 Body） */
export function tuEyeProtectionMode() {
  return request({
    url: '/api/Account/TuEyeProtectionMode',
    method: 'get'
  })
}

/** 未读消息统计：Body = { Total, Notice, Warning, Remind } */
export function GetTotalUnreadMessageCount() {
  return request({
    url: '/api/message/GetTotalUnreadMessageCount',
    method: 'post'
  })
}

/** 剩余可兑换鲜花额度 */
export function getLastFlowerAmount() {
  return request({
    url: '/api/teachInfo/LastFlowerAmount',
    method: 'post'
  })
}

/** 自主放课提示按钮 — Vue2 GetSelfScheduleRemind → Body { IsShow, Tips } */
export function getSelfScheduleRemind() {
  return request({
    url: "/api/Account/GetSelfScheduleRemind",
    method: "post",
  });
}

/** 修改邮箱 — 发验证码（发到原邮箱） */
export function SendChangeEmailVerificationEmail(email) {
  return request({
    url: '/api/Account/SendChangeEmailVerificationEmail',
    method: 'post',
    data: { Email: email }
  })
}

/** 修改邮箱 — 提交 */
export function ChangeTutorPrivateEmail(email, code, newEmail) {
  return request({
    url: '/api/Account/ChangeTutorPrivateEmail',
    method: 'post',
    data: { Email: email, Code: code, NewPrivateEmail: newEmail }
  })
}
